import React, { CSSProperties } from 'react'

interface InfoCardProps extends React.HTMLProps<HTMLDivElement> {
  icon?: JSX.Element;
  description?: string | JSX.Element;
  titleStyle?: CSSProperties;
  descriptionStyle?: CSSProperties;
}

function InfoCard({...props}:InfoCardProps) {
  return (
    <div className={`polymer-info-card ${props.className ? props.className : ''}`} style={{...props.style}}>
      {props.icon && <div className='polymer-info-card__icon'>{props.icon}</div>}
      <div style={{flex:1}}>
        {props.title && <div className='polymer-info-card__title'>
          <p style={{...props.titleStyle}}>{props.title}</p>
        </div>}
        <div>
          {typeof props.description === "string" && <div className='polymer-info-card__content' style={{...props.descriptionStyle}}><p>{props.description}</p></div>}
          {typeof props.description === "object" && <div className='polymer-info-card__content' style={{...props.descriptionStyle}}>{props.description}</div>}
        </div>
      </div>
    </div>
  )
}

export default InfoCard